import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { secondary } = theme.palette;

  return {
    scrollableContainer: {
      margin: "0 -24px",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        margin: "0 -16px"
      }
    },
    contentContainer: {
      height: "calc(100vh - 196px)",
      overflowY: "auto",
      padding: "0 24px"
    },
    entry: {
      paddingTop: 20,
      "&:first-child": {
        paddingTop: 14
      }
    },
    viewCommentsButton: {
      color: secondary.dark,
      height: 20,
      "& .MuiButton-label": {
        alignItems: "end"
      },
      "& .MuiButton-endIcon": {
        marginRight: 0
      },
      "& .MuiSvgIcon-root": {
        width: 16
      }
    },
    warning: {
      color: "#ff4a4e"
    },
    warningIcon: {
      width: 14,
      height: "auto",
      marginBottom: 1,
      marginLeft: 6
    },
    listType: {
      display: "flex",
      color: "#2d2d2d",
      fontWeight: 700,
      marginBottom: 9,
      lineHeight: "normal",
      whiteSpace: "nowrap",
      maxHeight: 18,
      overflow: "hidden",
      "&.warning": {
        color: "#ff4a4e"
      }
    },
    noResults: {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#c3c3c3",
      textTransform: "capitalize"
    },
    italic: {
      fontStyle: "italic"
    }
  };
});
